(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/responsive-image/assets/javascripts/image-helpers.js') >= 0) return;  svs.modules.push('/components/content/responsive-image/assets/javascripts/image-helpers.js'); 'use strict';

if (svs.isServer) {
  registerHelpers(require('hbs'), require('trinidad-core').core.config);
} else {
  registerHelpers(Handlebars, {
    options: svs.core.config.data.svsconfig
  });
}

var DEFAULT_MAXSIZE = 1920;
var DEFAULT_MINSIZE = 480;
var DEFAULT_STEPSIZE = 160;

function registerHelpers(hbs, config) {
  function isAbsoluteUrl(url) {
    return url && url.indexOf('http') === 0;
  }

  function getImageUrl(url, size) {
    url = isAbsoluteUrl(url) ? url : config.options.cdn2 + url;
    return url.replace('{width}', size);
  }

  hbs.registerHelper('imageSrcset', function (context) {
    var srcset = [];
    var max = parseInt(context.maxSize || DEFAULT_MAXSIZE, 10);
    var step = parseInt(context.stepSize || DEFAULT_STEPSIZE, 10);
    var size = parseInt(context.minSize || DEFAULT_MINSIZE, 10);

    do {
      srcset.push("".concat(getImageUrl(context.url, size), " ").concat(size, "w"));
      size += step;
    } while (size <= max);

    return new hbs.SafeString(srcset.join(','));
  });
}
 })(window);